import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { canonicalDestination } from "@/lib/canonicalOrigin";
import { CanonicalNavigation } from "@/components/CanonicalNavigation";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
const destination = canonicalDestination(window.location.href, process.env.REACT_APP_BACKEND_URL);
if (destination) {
  // No AuthProvider, AI session requests, install prompt or worker on an alias.
  // OAuth continues to derive its redirect from window.location.origin AFTER this navigation.
  root.render(<CanonicalNavigation destination={destination} />);
  try { window.location.replace(destination); } catch { /* The same trusted link remains available. */ }
} else {
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
}
